import { useRef } from 'react'
import { Canvas, useFrame, useThree } from '@react-three/fiber'
import { useIntersect, ScrollControls, Scroll } from '@react-three/drei'
import * as Tone from 'tone'
let randI = (i) => Math.floor(i * fxrand())
let rand = (arr) => arr[randI(arr.length)]
let scrollDistance = 7 + randI(15)
window.$fxhashFeatures = { scrollDistance }
let padLength = scrollDistance * 2
Tone.Transport.bpm.value = rand([10,20])
let mainGains = []
console.log(Tone.Transport.bpm.value)
let pads = new Array(padLength).fill().map(() => {
  let am = new Tone.AMSynth({
    "harmonicity": 1,
    "oscillator": {
      "type": "amsine2",
      "modulationType": "sine",
      "harmonicity": rand([1.01, 1.03, 1.01, 1.015, 1.0175, 1.0125, 1.04, 1])
    },
    "envelope": {
      "attack": '2n',
      "decay": '1m',
      "sustain": 0.5,
      "release": '2n'
    },
    "modulation": {
      "volume": rand([3, 5, 8, 10, 15]),
      "type": "amsine2",
      "modulationType": "sine",
      "harmonicity": rand([4, 8, 12, 16])
    },
    "modulationEnvelope": {
      "attack": '1m',
      "decay": 0.2,
      "sustain": 0.5,
      "release": '1m'
    }
  })
  let mainGain = new Tone.Gain(0).toDestination()
  mainGains.push(mainGain)
  let delay = new Tone.PingPongDelay('4n', 0.6).toDestination()
  am.connect(new Tone.Gain(0.2).connect(mainGain.connect(delay)))
  am.connect(new Tone.Gain(1.2).connect(new Tone.Panner((-10 + randI(20)) * 0.1).connect(mainGain)))
  return am
})
let positions = new Array(padLength).fill().map(() => [
  rand([1, -1]) * ((randI(45)) * 0.01),
  randI(190) * scrollDistance * 0.005,
])
positions[0] = [
  rand([1, -1]) * ((randI(50)) * 0.01),
  randI(100) * 0.005,
]
let notes = new Array(padLength).fill().map(() => rand(['C', 'D', 'E', 'G', 'A']) + rand([1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3]))
let scales = new Array(padLength).fill().map(() => 0.2 + (randI(30) * 0.1))
let volumes = new Array(padLength).fill().map(() => 0.1 + (randI(35) * 0.01))
let visible = new Array(padLength).fill().map(() => false)
function Item({ i }) {
  const playing = useRef(false)
  const ref = useIntersect((isVisible) => (visible[i] = isVisible))
  const { height, width } = useThree((state) => state.viewport)
  let scale = scales[i]
  useFrame(() => {
    if (visible[i]) {
      if (!playing.current) {
        pads[i].triggerAttack(notes[i], '+0.0000001', volumes[i])
        playing.current = true
      }
    } else {
      pads[i].triggerRelease()
      playing.current = false
    }
  })
  return (
    <group position={[
      positions[i][0] * width,
      -positions[i][1] * height,
      0
    ]}>
      <mesh ref={ref} scale={[scale*0.25, scale*1.5, scale]}>
        <meshBasicMaterial color={'black'} />
        <boxBufferGeometry />
      </mesh>
    </group>
  )
}

function All() {
  return (
    <Scroll>
      {new Array(padLength).fill().map((_, i) => <Item i={i} key={i} />)}
    </Scroll>
  )
}
let started = false
let togglable = true
const click = () => {
  if (togglable) {
    if (!started) {
      Tone.start();
      Tone.Transport.start()
      started = true
      mainGains.forEach((g) => g.gain.linearRampTo(1, 1));
      document.getElementById('overlay').style.opacity = 0
      setTimeout(() => (togglable = true), 1100)
    } else {
      started = false
      mainGains.forEach((g) => g.gain.linearRampTo(0, 1.5));
      document.getElementById('overlay').style.opacity = 1
      setTimeout(() => (togglable = true), 1600)
    }
    togglable = false
  }
}
export const App = () => (
  <div id="main" onClick={() => click()} >
    <div id="overlay" />
    <Canvas orthographic camera={{ zoom: 80 }} gl={{ alpha: false, antialias: false, stencil: false, depth: false }} dpr={[1, 1.5]}>
      <color attach="background" args={['#ffffff']} />
      <ScrollControls distance={0.9} damping={10} pages={scrollDistance}>
        <All />
      </ScrollControls>
    </Canvas>
  </div>
)

console.log('%c ⬛⬛ @ramioso 2022-09-14 ⬛⬛', 'color: orange');
